import { render, staticRenderFns } from "./bonus-register-pdf.vue?vue&type=template&id=f8c24a48&scoped=true&"
import script from "./bonus-register-pdf.vue?vue&type=script&lang=js&"
export * from "./bonus-register-pdf.vue?vue&type=script&lang=js&"
import style0 from "./bonus-register-pdf.vue?vue&type=style&index=0&id=f8c24a48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c24a48",
  null
  
)

export default component.exports